<template>
	<div class="distributor-address-list">
		<div class="common-header-wrap">
			<mt-header :title="$t('Delivery Address')" class="common-header">
				<mt-button slot="left" icon="back" @click="goBack"></mt-button>
			</mt-header>
		</div>

		<div class="pb-30" v-if="address_list.length > 0">
			<div class="item" v-for="item in address_list" :key="item.address_id">
				<div class="container">
					<div class="top-wrapper">
						<div class="selected-wrapper">
							<div class="line">
								<!-- <i class="icon iconfont">&#xe6d3;</i> -->
								<div class="line-content">
									<div class="title-wrapper">
										<label class="title" style="margin-right:.5rem;">{{ item.address_realname }}</label>
										<label class=" title" style="margin-right:.5rem;">
											{{ item.address_mob_phone }}</label>
										<label class="title dadd" v-if="item.address_is_default == 1">
											{{ $t('Default address') }}
										</label>
									</div>
									<div class="desc address-text">{{ item.area_info }}{{ item.address_detail }}</div>
									<div class="desc address-text-cityerror" v-if="item.cityerror">
										{{ $t('The store is no longer valid, please edit the delivery address again') }}
									</div>
								</div>
							</div>
						</div>
						<div class="ed">
							<div class="icon" @click="onEdit(item)">
								<img src="../../../assets/image/home/ed.png" />
							</div>
						</div>
					</div>

					<!-- <div class="bottom-wrapper">
						<div class="bottom-left-wrapper" @click="onDefault(item)">
							<label class="subtitle">
								<i v-if="item.address_is_default == 1" class="iconfont">&#xe69d;</i><i v-else
									class="iconfont">&#xe69e;</i>{{ $t('Default address') }}
							</label>
						</div>
						<div class="bottom-right-wrapper">
							<div class="edit-wrapper" @click="onEdit(item)">
								<div class="common-btn btn-2 mr-5">{{ $t('Edit') }}</div>
							</div>
							<div class="edit-wrapper delete-wrapper" @click="onDelete(item.address_id)">
								<div class="common-btn btn-1">{{ $t('Delete') }}</div>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
		<div v-else>
			<!-- <empty-record></empty-record> -->
			<img style="width: 10rem;margin: 3rem auto;display: block;" src="../../../assets/image/home/add-none.png" />
		</div>
		<div class='common-add-btn-wrapper' style="bottom: 1rem;">
			<div class="div common-btn ds-button-large" style="margin: 0;" @click="goAdd">
				{{ $t('Add address') }}
			</div>
		</div>
	</div>
</template>

<script>

import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../EmptyRecord'
import { getAddressList, delAddress, editAddress } from '../../../api/memberAddress'
export default {
	components: {
		EmptyRecord
	},
	name: 'MemberAddressList',
	data() {
		return {
			address_list: []
		}
	},
	created: function () {
		this.getAddressList()
	},
	mounted() {
		window.scrollTo(0, 0);
	},
	methods: {
		goBack() {
			this.$router.go(-1)
		},
		goAdd() {
			this.$router.push({ name: 'MemberAddressForm', query: { action: 'add' } })
		},
		onDefault(address_info) {
			address_info.address_is_default = 1
			editAddress(address_info, address_info.address_id).then(
				(response) => {
					Indicator.close()
					this.getAddressList()
				}, (error) => {
					Indicator.close()
					Toast(error.message)
				})
		},
		onEdit(address) {
			if (!address.chain_id) {
				this.$router.push({ name: 'MemberAddressForm', query: { address_id: address.address_id } })
			} else {
				this.$router.push({ name: 'MemberChainForm', query: { address_id: address.address_id, action: 'edit' } })
			}
		},
		onDelete(addressId) {
			let that = this
			MessageBox({
				title: that.$t('MessageBox.Tips'),
				message: that.$t('MessageBox.delete.address'),
				confirmButtonText: that.$t('MessageBox.Confirm'),
				cancelButtonText: that.$t('MessageBox.Cancel'),
				showCancelButton: true
			}).then(action => {
				if (action == 'confirm') {
					Indicator.open()
					delAddress(addressId).then(
						(response) => {
							this.getAddressList()
							Indicator.close()
						}, (error) => {
							Indicator.close()
							Toast(error.message)
						})
				}
			});
		},
		getAddressList() {
			getAddressList().then(res => {
				this.address_list = res.result.address_list
			}).catch(function (error) {
				Toast(error.message)
			})
		}
	}
}
</script>
<style  lang="scss" scoped>
.ds-button-large {
	width: 80%;
	position: fixed;
	bottom: 2rem;
	left: 50%;
	transform: translateX(-50%);
	background: #E7010C;
	padding: .2rem;
}

.distributor-address-list {
	min-height: 100vh;
	background: #fff;

	.common-header {
		box-shadow: none;

		.btn {
			background: #000;
			color: #fff;
			box-shadow: 0px 2px 4px #d2d2d2;
		}
	}

	.line {
		display: flex;

		.line-content {
			flex: 1
		}
	}

	.item {
		margin: 1rem;
		padding: 1rem .8rem;
		background: #FAFAFA;
		border-radius: 5px 5px 5px 5px;
	}

	.container {
		background: #FAFAFA;
		// padding: 0 $pageSpace
	}

	.btn-1 {
		border: 1px solid $primaryColor;
		color: $primaryColor;
		min-width: 2rem
	}

	.btn-2 {
		border: 1px solid #333;
		color: #333;
		min-width: 2rem
	}

	.top-wrapper {
		position: relative;
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		background: #FAFAFA;

		.ed {
			.icon {
				width: .8rem;
				height: .8rem;

				img {
					width: 100%;
					height: 100%;
					display: block;
				}
			}
		}
	}

	.title-wrapper {
		// height: 1rem;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
	}

	.icon {
		font-size: $h1;
		margin-right: .2rem;
		color: $primaryColor
	}

	.title {
		font-size: $h3;
		color: #333;
		font-weight: 700;
	}

	.dadd {
		background-color: #F9E1E2;
		border-radius: .8rem;
		font-size: 10px;
		color: #E7010C;
		text-align: center;
		padding: .2rem .6rem;
	}

	.default {
		width: 1.4rem;
		margin-left: 0.5rem;
		margin-right: 0.5rem;
		border: 1px solid $primaryColor;
		color: $primaryColor;
		font-size: $h6;
		text-align: center;
		border-radius: 0.1rem;
	}

	.desc {
		color: $descTextColor;
		font-size: $subFontSize;
	}

	.address-text {
		margin-top: .3rem;
		font-weight: normal;
	}

	.address-text-cityerror {
		margin-top: .3rem;
		font-weight: normal;
		color: #ff4040;
	}

	.selected-wrapper {
		padding: 1rem 0;
	}

	.bottom-line {
		position: absolute;
		left: 0;
		bottom: 0;
		right: 0;
		border-bottom: 1px dashed #eee
	}

	.bottom-wrapper {
		height: 2.5rem;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: stretch;
		align-items: center;
	}

	.bottom-left-wrapper {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.bottom-right-wrapper {
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: stretch;
	}

	.edit-wrapper {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}

	.delete-wrapper {
		margin-right: 0.5rem;
	}

	.subtitle {
		font-size: $subFontSize;
		color: $descTextColor;
	}

	.subtitle i {
		font-size: $h2;
		margin-right: .5rem;
	}
}
</style>
